import type { ReactElement } from 'react'
import { useIntl } from 'react-intl'

import { Button, Typography } from '@themenu/design-system'

import { SwileLogo } from '../components/Shared/Images'

interface UpdateAppPageProps {
  // Opens the Play Store listing for the Swile app (the "update" CTA).
  onUpdate: () => void
  // Resumes the already-completed login (the "I already updated" CTA).
  onRelaunch: () => void
}

// Presentational "update your app" page shown to outdated Android clients.
// All routing/side-effect logic lives in UpdateAppRoute; this component only
// renders the markup and delegates the two CTAs to its props (so it can be
// rendered in isolation, e.g. Storybook).
export const UpdateAppPage = ({ onUpdate, onRelaunch }: UpdateAppPageProps): ReactElement => {
  const intl = useIntl()

  return (
    <main
      className={
        'flex h-dvh flex-col items-center justify-center gap-16 bg-background-default p-24 dark:bg-background-default-dark'
      }
    >
      <SwileLogo />
      <Typography variant="largeTitle" align="center">
        {intl.formatMessage({ id: 'update_app.title' })}
      </Typography>
      <Typography variant="body" align="center">
        {intl.formatMessage({ id: 'update_app.body' })}
      </Typography>
      <Button onClick={onUpdate}>{intl.formatMessage({ id: 'update_app.cta.update' })}</Button>
      <Button variant="secondary" onClick={onRelaunch}>
        {intl.formatMessage({ id: 'update_app.cta.already_updated' })}
      </Button>
    </main>
  )
}
